export const FETCH_FEATURE_FLAGS_REQUEST = "FETCH_FEATURE_FLAGS_REQUEST";
export const FETCH_FEATURE_FLAGS_SUCCESS = "FETCH_FEATURE_FLAGS_SUCCESS";
export const FETCH_FEATURE_FLAGS_FAILURE = "FETCH_FEATURE_FLAGS_FAILURE";

export const UPDATE_FEATURE_FLAG_REQUEST = "UPDATE_FEATURE_FLAG_REQUEST";
export const UPDATE_FEATURE_FLAG_SUCCESS = "UPDATE_FEATURE_FLAG_SUCCESS";
export const UPDATE_FEATURE_FLAG_FAILURE = "UPDATE_FEATURE_FLAG_FAILURE";

export const FETCH_FEATURE_FLAG_REQUEST = "FETCH_FEATURE_FLAG_REQUEST";
export const FETCH_FEATURE_FLAG_SUCCESS = "FETCH_FEATURE_FLAG_SUCCESS";
export const FETCH_FEATURE_FLAG_FAILURE = "FETCH_FEATURE_FLAG_FAILURE";
